import { render, staticRenderFns } from "./PersonalRep.vue?vue&type=template&id=48881444&scoped=true&"
import script from "./PersonalRep.vue?vue&type=script&lang=js&"
export * from "./PersonalRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48881444",
  null
  
)

export default component.exports